import * as mongoose from 'mongoose';
import { modelOptions, prop, Severity } from '@typegoose/typegoose';
import { Filter } from './filters.model';
import { Column } from '@nirvana/shared/dtos/types/shared/filters';
import { ColumnKeys, ViewType } from '@nirvana/shared/dtos/types/alerts/common';

@modelOptions({ options: { allowMixed: Severity.ALLOW } })
export class ViewConfiguration {
  @prop({ required: true })
  _id: mongoose.Types.ObjectId;

  @prop({ required: true })
  name: string;

  @prop({ required: true, enum: ViewType, type: Number })
  type: ViewType;

  @prop({
    required: true,
    type: mongoose.Schema.Types.Mixed, // We need this to be able to insert multiple schema types in the filter field
    _id: false,
  })
  filters: Array<Filter>;

  @prop({ required: true, type: Number, enum: Column })
  displayedColumns: Array<Column>;

  @prop({ required: true, type: Boolean })
  compactView: boolean;

  @prop({ required: true, type: Number })
  pageSize: number;

  @prop({
    required: false,
    type: mongoose.Schema.Types.Mixed,
    _id: false,
  })
  columnConfigs?: Array<ColumnConfiguration>;

  @prop({ required: false, type: Boolean })
  isShared?: boolean;
}

export class ColumnConfiguration {
  @prop({ required: true, type: String, enum: ColumnKeys })
  key: string;

  @prop({ required: true, type: String })
  width: string;
}

@modelOptions({ schemaOptions: { collection: 'alerts' }, options: { customName: 'alerts' } })
export class AlertsConfig {
  @prop({
    required: true,
    index: true,
    unique: true,
  })
  userId: mongoose.Types.ObjectId;

  @prop({ required: true })
  activeViewId: string;

  @prop({ required: true })
  viewsPanelOpen: boolean;

  @prop({
    required: true,
    index: true,
  })
  companyId: mongoose.Types.ObjectId;

  @prop({ required: true, type: ViewConfiguration, _id: true })
  views: Array<ViewConfiguration>;
}
